<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">PT Commission Tier Setting</div>
        <div class="mb-10 color-muted font-13">
          Tier persen komisi AFM/SPV/FM berdasarkan volume run/sell, & batas maksimal
          persen berdasarkan club achievement. Berlaku untuk semua PT dengan role
          tersebut, langsung aktif begitu disimpan (termasuk bulan yang sedang berjalan).
        </div>

        <div class="box-mini mb-20">
          <div class="row p-15 pb-0">
            <div class="col-12">
              <div class="font-bold">Volume Tier (per Role)</div>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Role</th>
                  <th>Tier %</th>
                  <th>Min Run</th>
                  <th>Min Sell</th>
                  <th>Active</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in volumeTiers" :key="'vt-' + (item.id || 'new-' + item._tempId)">
                  <td>
                    <b-form-select v-model="item.role" class="form-control">
                      <option value="afm">AFM</option>
                      <option value="spv">SPV</option>
                      <option value="fm">FM</option>
                    </b-form-select>
                  </td>
                  <td><b-form-input v-model.number="item.tier_percent" type="number"></b-form-input></td>
                  <td><b-form-input v-model.number="item.min_run" type="number"></b-form-input></td>
                  <td><b-form-input v-model.number="item.min_sell" type="number"></b-form-input></td>
                  <td class="text-center"><input type="checkbox" v-model="item.is_active"></td>
                  <td>
                    <b-button size="sm" class="btn-table green" @click="saveVolumeTier(item)">Save</b-button>
                    <b-button size="sm" class="btn-table danger" v-if="item.id" @click="deleteVolumeTier(item)">Delete</b-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <a @click="addVolumeTierRow()" class="btn-secondary mr-5"><i class="fas fa-plus-square mr-5"></i>Add Tier</a>
          </div>
        </div>

        <div class="box-mini mb-20">
          <div class="row p-15 pb-0">
            <div class="col-12">
              <div class="font-bold">Achievement Cap (AFM/SPV/FM)</div>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Min Achievement %</th>
                  <th>Max Percent</th>
                  <th>Active</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in achievementCaps" :key="'ac-' + (item.id || 'new-' + item._tempId)">
                  <td><b-form-input v-model.number="item.min_achievement_percent" type="number"></b-form-input></td>
                  <td><b-form-input v-model.number="item.max_percent" type="number"></b-form-input></td>
                  <td class="text-center"><input type="checkbox" v-model="item.is_active"></td>
                  <td>
                    <b-button size="sm" class="btn-table green" @click="saveAchievementCap(item)">Save</b-button>
                    <b-button size="sm" class="btn-table danger" v-if="item.id" @click="deleteAchievementCap(item)">Delete</b-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <a @click="addAchievementCapRow()" class="btn-secondary mr-5"><i class="fas fa-plus-square mr-5"></i>Add Cap</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ptCommissionTierIndex',
  data: function () {
    return {
      volumeTiers: [],
      achievementCaps: [],
      tempIdCounter: 0
    }
  },
  methods: {
    addVolumeTierRow () {
      this.tempIdCounter++
      this.volumeTiers.push({ _tempId: this.tempIdCounter, role: 'afm', tier_percent: 0, min_run: 0, min_sell: 0, is_active: true })
    },
    addAchievementCapRow () {
      this.tempIdCounter++
      this.achievementCaps.push({ _tempId: this.tempIdCounter, min_achievement_percent: 0, max_percent: 0, is_active: true })
    },
    saveVolumeTier (item) {
      const payload = { role: item.role, tier_percent: item.tier_percent, min_run: item.min_run, min_sell: item.min_sell, is_active: item.is_active }
      const request = item.id
        ? axios.put('crm/v1/pt_commission_tier_setting/volume_tier/' + item.id, payload)
        : axios.post('crm/v1/pt_commission_tier_setting/volume_tier', payload)
      request.then(() => {
        this.$toast.success('data saved successfully!', 'Success', {
          position: 'topCenter', icon: 'icon-envelope', progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark', backgroundColor: '#565c70', messageColor: '#fff'
        })
        this.fetchData()
      }).catch(error => {
        console.log('error', error)
        this.$toast.success('cant saved data!', 'Error', {
          position: 'topCenter', icon: 'icon-envelope', progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark', backgroundColor: '#565c70', messageColor: '#fff'
        })
      })
    },
    saveAchievementCap (item) {
      const payload = { min_achievement_percent: item.min_achievement_percent, max_percent: item.max_percent, is_active: item.is_active }
      const request = item.id
        ? axios.put('crm/v1/pt_commission_tier_setting/achievement_cap/' + item.id, payload)
        : axios.post('crm/v1/pt_commission_tier_setting/achievement_cap', payload)
      request.then(() => {
        this.$toast.success('data saved successfully!', 'Success', {
          position: 'topCenter', icon: 'icon-envelope', progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark', backgroundColor: '#565c70', messageColor: '#fff'
        })
        this.fetchData()
      }).catch(error => {
        console.log('error', error)
        this.$toast.success('cant saved data!', 'Error', {
          position: 'topCenter', icon: 'icon-envelope', progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark', backgroundColor: '#565c70', messageColor: '#fff'
        })
      })
    },
    deleteVolumeTier (item) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Tier ini akan dihapus.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          axios.delete('crm/v1/pt_commission_tier_setting/volume_tier/' + item.id).then(() => {
            this.$swal('Deleted', 'Tier berhasil dihapus', 'success')
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        }
      })
    },
    deleteAchievementCap (item) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Cap ini akan dihapus.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          axios.delete('crm/v1/pt_commission_tier_setting/achievement_cap/' + item.id).then(() => {
            this.$swal('Deleted', 'Cap berhasil dihapus', 'success')
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        }
      })
    },
    fetchData () {
      axios.get('crm/v1/pt_commission_tier_setting/volume_tier').then(response => {
        this.volumeTiers = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/pt_commission_tier_setting/achievement_cap').then(response => {
        this.achievementCaps = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
